import { postRequestEditCheck } from "@/api/user/home";
import { CreditDataMain } from "@/types/api/user/home.type.data";
import CustomButton from "@/shared/components/kit/button";
import StackKit from "@/shared/components/kit/stack";
import TypoGraphyKit from "@/shared/components/kit/typoGraphy";
import { CircularProgress, Grid } from "@mui/material";
import { useMutation } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { useState } from "react";
import { toast } from "react-toastify";
/**
 * EditInformationReview
 *
 * کامپوننت نمایش وضعیت اعتبارسنجی برای چک‌های رد شده و امکان بارگذاری مجدد تصاویر.
 * این کامپوننت شامل:
 * - نمایش توضیحات وضعیت اعتبارسنجی و دلایل رد چک‌ها.
 * - نمایش تصاویر چک‌هایی که تایید نشده‌اند.
 * - امکان بارگذاری مجدد تصاویر برای چک‌های رد شده.
 * - ارسال تصاویر اصلاح شده به سرور با استفاده از API و نمایش وضعیت پردازش.
 *
 * @param {Object} props
 * @param {CreditDataMain | undefined} props.userInquiry داده‌های اعتبار کاربر شامل چک‌ها
 *
 * @component
 * @returns JSX.Element
 */

const EditInformationReview = ({userInquiry,}: {userInquiry: CreditDataMain | undefined;}) => {
  const [uploadedImagesArray, setUploadedImagesArray] = useState<Record<number, string>>(() =>
      userInquiry?.userCheck.reduce((acc, check) => {
        acc[check.id] = "";
        return acc;
      }, {} as Record<number, string>) || {}
  );

  const { mutate: fetchRequestEditCheck, isPending: isPendingLogin } =
    useMutation({
      mutationFn: postRequestEditCheck,
      onSuccess: (data: any) => {
        window.location.reload();
      },
      onError: (error: AxiosError<{ message: string }>) => {
        toast.error(error?.response?.data?.message);
      },
    });

  const handleClick = () => {
    const existingData = userInquiry?.user_check || [];
    const newData =
      userInquiry?.credit_data_details.filter((check) => check.status === 0).map((check) => {
          return {
            id: check.id,
            image: uploadedImagesArray[check.id],
          };
        }) || [];
    const requestBody = {user_check: [...existingData, ...newData],};

    fetchRequestEditCheck(requestBody);
  };

  const handleUpload = (event: React.ChangeEvent<HTMLInputElement>,checkId: number) => {
    const file = event.target.files?.[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onloadend = () => {
      setUploadedImagesArray((prev: any) => ({
        ...prev,
        [checkId]: reader.result as string,
      }));
    };
    reader.readAsDataURL(file);
  };

  return (
    <Grid>
      <Grid>
        <TypoGraphyKit variant="h6">
          وضعیت اعتبار سنجی: درخواست اصلاح چک
        </TypoGraphyKit>
      </Grid>
      <Grid sx={{display: "flex",flexDirection: "row",justifyContent: "start",marginBlock: "50px",}}>
        <TypoGraphyKit sx={{ textAlign: "right" }}>
          کاربر گرامی ،<br /> مطابق بررسی های انجام شده؛تصاویر چک ارسالی دارای
          مشکل میباشد. لطفا پس از بررسی تصویر و دلیل رد شدن آن؛ نسبت به بارگزاری
          مجدد تصاویر اقدام نمایید.
        </TypoGraphyKit>
      </Grid>
      <Grid>
        <StackKit alignItems={"start"}>
          <TypoGraphyKit variant="body1">
            تصاویر زیر مورد تایید قرار نگرفته اند:
          </TypoGraphyKit>
          <Grid sx={{display: "flex",justifyContent: "center",gap: 2,width: "100%",}}>
            <StackKit direction="column" alignItems={"center"} gap={2}>
              {userInquiry?.credit_data_details.map((check) => {
                return check?.status === 0 ? (
                  <StackKit key={check.id} direction="column" alignItems="center" gap={2}>
                    <img src={uploadedImagesArray[check.id] || check?.image} alt={check.title} style={{width: "100%",maxWidth: "249px",height: "auto",aspectRatio: "249/117",borderRadius: "8px",}}/>
                    <TypoGraphyKit variant="body1" sx={{ color: "red" }}>
                      {check?.description}
                    </TypoGraphyKit>
                    <CustomButton component="label" sx={{ marginTop: "50px" }}>
                      بارگذاری تصویر
                      <input type="file" hidden onChange={(e) => handleUpload(e, check.id)}/>
                    </CustomButton>
                  </StackKit>
                ) : null;
              })}
            </StackKit>
          </Grid>
        </StackKit>
      </Grid>
      <StackKit direction={"row"} sx={{ width: "100%", justifyContent: "space-between" }}>
        <CustomButton>صفحه اصلی</CustomButton>
        <CustomButton
          disabled={!Object.values(uploadedImagesArray).some((val) => val !== "")}
          onClick={!isPendingLogin ? handleClick : () => {}}
        >
          {isPendingLogin ? (
            <CircularProgress sx={{ color: "#fff" }} size={24} />
          ) : (
            <TypoGraphyKit variant="body1">ویرایش</TypoGraphyKit>
          )}
        </CustomButton>
      </StackKit>
    </Grid>
  );
};

export default EditInformationReview;
